// Check if the current URL matches a specific condition
// INFINITE COLLECTION
var pInfScrLoading = false;
var pInfScrDelay = 100;

function pInfScrExecute() {
  console.log(
    $("#CollectionAjaxContent .product-list-wrapper_main").height() - 700,
    $(document).scrollTop()
  );
  if (
    $("#CollectionAjaxContent .product-list-wrapper_main").height() - 700 <
    $(document).scrollTop()
  ) {
    console.log("idfff");
    var loadingImage;
    pInfScrNode = $(".product-list__inner").last().find(".more").last();
    pInfScrURL = $(".product-list__inner")
      .last()
      .find(".more a")
      .last()
      .attr("href");
    if (!pInfScrLoading && pInfScrNode.length > 0) {
      console.log("innnnnidfff");
      $(".collection-grid__wrapper").append(
        '<img src="https://cdn.shopify.com/s/files/1/0748/1507/8709/files/Spinner-1s-200px.gif?v=1709214628" class="loading" style="display:block; margin:auto;" />'
      );
      $.ajax({
        type: "GET",
        url: pInfScrURL,
        beforeSend: function () {
          pInfScrLoading = true;
          loadingImage = pInfScrNode.clone().empty().append("");
          loadingImage.insertAfter(pInfScrNode);
          pInfScrNode.hide();

          console.log("loading...");
        },
        success: function (data) {
          // remove loading feedback
          pInfScrNode.next().remove();
          var filteredData = $(data).find(".product-list__inner");
          filteredData.insertBefore($("#product-list-foot"));
          loadingImage.remove();
          pInfScrLoading = false;
          $(".collection-grid__wrapper").find(".loading").remove();
          pInfScrLoading = false;
          document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
        },
        dataType: "html",
      });
    }
  }
}

$(document).ready(function () {
  
  $(window).scroll(function () {
    $.doTimeout("scroll", pInfScrDelay, pInfScrExecute);

    if (
      $("#CollectionAjaxContent .product-list-wrapper_main").height() - 700 <
      $(document).scrollTop()
    ) {
      pInfScrDelay = 20;
    }
  });

  $("body").on(
    "click",
    ".grid__item .quick-add-product__btn .quick-addtocart",
    function () {
      var _this = $(this);
      var vid = _this.attr("data-vid");
      $(".quick-add-product__btn .errors").remove();
      fetch("/cart/add.js", {
        method: "POST",
        body: JSON.stringify({
          quantity: 1,
          id: vid,
        }),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          "X-Requested-With": "XMLHttpRequest",
        },
      })
        .then((response) => response.json())
        .then(
          function (data) {
            if (data.status === 422) {
              console.log(data);
              _this.before('<p class="errors">' + data.description + "</p>");
              setTimeout(function () {
                $(".quick-add-product__btn .errors").remove();
              }, 5000);
            } else {
              document.dispatchEvent(
                new CustomEvent("ajaxProduct:added", {
                  detail: {
                    product: data,
                  },
                })
              );
            }
          }.bind(this)
        );
    }
  );

  $("body").on("click", ".order-note-toggle", function () {
    $(this).siblings(".cartdrawer_note").addClass("active");
  });
  $("body").on("click", ".cart_note_close", function () {
    $(this).parent(".cartdrawer_note").removeClass("active");
  });

  $("body").on("click", ".cartdrawer_note_inr .order_note_save", function () {
    var cartNote = $(this).siblings("#CartNoteDrawer").val();
    console.log("cartNote", cartNote);
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ note: cartNote }),
      keepalive: true,
      // Allows to make sure the request is fired even when submitting the form
    });
    $(this)
      .closest(".cartdrawer_note_wrap")
      .find(".cartdrawer_note")
      .removeClass("active");
  });
});
